module.exports = __webpack_public_path__ + "static/archivo-4aedd75230d7b328140247bf736edae5.png";